import {
  connect,
} from 'react-redux';
import {
  withRouter,
} from '@vroskus/library-navigation';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as authActions,
} from '../../../redux/modules/auth';
import {
  actions as mainActions,
} from '../../../redux/modules/main';

import HeaderView from './HeaderView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './HeaderView';

const mapStateToProps = ({
  auth,
  main,
}: $State): $StateProps => ({
  auth,
  main,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  authenticate: (params) => dispatchAction(
    authActions.authenticate(params),
  ),
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
  setRegion: (params) => dispatchAction(
    mainActions.setRegion(params),
  ),
  setupUser: (params) => dispatchAction(
    mainActions.setupUser(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderView);

const RoutedComponent = withRouter(ConnectedComponent);

const TranslatedComponent = withTranslation()(RoutedComponent);

const Component = TranslatedComponent;

export default Component;
